import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css"; // Required for styling
import $ from "jquery"; // Required for jQuery to work with DataTable
import "datatables.net"; // Import DataTable jQuery plugin

function UserGeoTags() {
  const navigate = useNavigate();
  const location = useLocation(); // Access the current location (URL)
  const [requestData, setRequestData] = useState([]); // Initialize as an empty array
  const [dataTable, setDataTable] = useState(null);
  const [user, setUser] = useState();
  // Extract query parameter 'id' from the URL
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id"); // Get the 'id' from the query string
  const GeoTagsType = queryParams.get("type"); // Get the 'id' from the query string

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(requestData) && requestData.length > 0) {
      // Check if the table element exists and is rendered
      if ($("#geotags").length) {
        // Destroy any existing DataTable instance before reinitializing
        if (dataTable) {
          dataTable.destroy(true); // Ensure it destroys the previous table instance
        }

        // Initialize the DataTable after data is set
        requestAnimationFrame(() => {
          const table = $("#geotags").DataTable({
            processing: true,
            data: requestData,
            columns: [
              { data: null, render: (data, type, row, meta) => meta.row + 1 },
              {
                data: "text",
                render: (data) => data || "N/A", // Mobile number from user object
              },
              {
                data: "geoTagPlace",
                render: (data, type, row) => {
                  // Check if geoTagPlace is valid and create a link
                  if (data) {
                    const latitude = row.latitude;
                    const longitude = row.longitude;
                    return `<a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">${data}</a>`;
                  } else {
                    return "N/A";
                  }
                }, // Geo tag place info with hyperlink
              },
              {
                data: "latitude",
                render: (data) => data || "N/A", // Latitude
              },
              {
                data: "longitude",
                render: (data) => data || "N/A", // Longitude
              },
              {
                data: "createdAt",
                render: (data) => new Date(data).toLocaleString() || "N/A", // CreatedAt date
              },
              {
                data: null,
                render: (data) => `
                    <div align="center">
                        <a href="geotag_view?id=${data.geoTagId}" class="crsr_pntr" target="_blank"><i class="fa-solid fa-eye mr-2"></i></a>
                    </div>
                `,
              },
            ],
            pageLength: 5,
            lengthMenu: [5, 10, 25, 50, 75, 100],
            responsive: true,
          });

          setDataTable(table);
        });
      }
    }
  }, [requestData]); // Only run this effect when `requestData` changes

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userAdditionalInfo",
          module: "user",
          userId: userId,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        setUser(data.result.userDetails[0].user);
        setRequestData(
          GeoTagsType === "opened"
            ? data.result.userDetails[0].openedGeotags
            :GeoTagsType === "hunted"
            ? data.result.userDetails[0].huntedGeotags
            : GeoTagsType === "saved"
            ? data.result.userDetails[0].savedGeotags
            : GeoTagsType === "created"
            ? data.result.userDetails[0].createdGeotags
            : data.result.userDetails[0].createdGeotags || [] // Default to 'createdGeotags'
        );
      } else {
        console.error("Failed to fetch geotags:", data);
        setRequestData([]); // Clear data if fetching fails
      }
    } catch (error) {
      console.error("Error fetching geotag data:", error);
      setRequestData([]); // Clear data if there's an error
    }
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  {GeoTagsType === "created"
                    ? "Dropped"
                    : GeoTagsType === "opened"
                    ? "Opened"
                    :GeoTagsType === "hunted"
                    ? "Hunted"
                    : GeoTagsType === "saved"
                    ? "Saved"
                    : ""}{" "}
                  - ({user?.countryCode || ""}
                  {user?.mobile || ""})
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                {/* Conditional rendering for "No records" message */}
              
                  <div className="table-responsive">
                    <table
                      id="geotags"
                      className="table table-striped table-bordered txt_lft"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Text</th>
                          <th>Geo Tag Place</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                          <th>CreatedAt</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Data rows will be populated by DataTable */}
                      </tbody>
                    </table>
                  </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default UserGeoTags;
